export const WIDTH_XL = 1280;
export const MAX_WIDTH_XL = 1279;
export const WIDTH_LG = 992;
export const MAX_WIDTH_LG = 991;
export const WIDTH_MD = 768;
export const MAX_WIDTH_MD = 767;
export const WIDTH_SM = 576;
export const MAX_WIDTH_SM = 575;
